export const LINK_TYPES = [
  "Discord",
  "Rules",
  "Twitch",
  "X",
  "YouTube",
] as const;
export type LinkType = (typeof LINK_TYPES)[number];

const LINK_ORDER = ["Rules", "Twitch", "YouTube", "Discord", "X"] as const;

export type Link = {
  hover: string | undefined;
  type: LinkType | undefined;
  url: string | undefined;
};

export type Links = Link[];

export const getLinkTitle = (link: Link) => {
  return link.hover ?? getDefaultLinkTitle(link.type);
};
export const getSortedLinks = (links: Links) => {
  return [...links].sort((a, b) => {
    if (a.type === b.type) {
      return 0;
    }

    if (!a.type) {
      return -1;
    }

    if (!b.type) {
      return 1;
    }

    return LINK_ORDER.indexOf(a.type) - LINK_ORDER.indexOf(b.type);
  });
};

export const getLinkIconPath = (type: LinkType | undefined) => {
  switch (type) {
    case "Discord":
      return "/images/icons/discord-dark.png";
    case "Rules":
      return "/images/icons/rules.png";
    case "Twitch":
      return "/images/icons/twitch-dark.png";
    case "X":
      return "/images/icons/x-dark.png";
    case "YouTube":
      return "/images/icons/youtube-dark.png";
    default:
      return undefined;
  }
};

const getDefaultLinkTitle = (type: LinkType | undefined) => {
  switch (type) {
    case "Discord":
      return "Join Discord";
    case "Rules":
      return "View Rulebook";
    case "Twitch":
      return "Watch Twitch";
    case "X":
      return "View X Account";
    case "YouTube":
      return "Watch YouTube";
  }
};
